import * as Yup from 'yup';
import { AssertSchemaMatchesModel, validateContract } from '../validateContract';
import { VehicleOptionType } from './enums';
import { baseAmountSchema as amountSchema } from './webCalcAmount.schema';
import { WebCalcRequest } from './webCalcRequest.model';

export const webCalcRequestSchema = Yup.object({
  correlationId: Yup.string().optional(),
  context: Yup.object({
    domain: Yup.string().optional(),
  }).optional(),
  vehicle: Yup.object({
    model: Yup.object({
      code: Yup.string().optional(),
      codeType: Yup.string().optional(),
      options: Yup.array(
        Yup.object({
          id: Yup.string().optional(),
          prKey: Yup.string().optional(),
          type: Yup.mixed<VehicleOptionType>().oneOf(Object.values(VehicleOptionType)).optional(),
          optionPriceAmount: amountSchema.optional(),
        })
      ).optional(),
    }).optional(),
    isUsed: Yup.boolean().optional(),
    baseModelPriceAmount: amountSchema.optional(),
    retailPriceAmount: amountSchema.optional(),
    priceDetails: Yup.object({
      isExcludingVAT: Yup.boolean().optional(),
    }).optional(),
  }).optional(),
  financialProduct: Yup.object({
    parameters: Yup.array(
      Yup.object({
        id: Yup.string().required(),
        value: Yup.string().required(),
      }).required()
    ).optional(),
    campaign: Yup.object({ id: Yup.string().optional() }).optional(),
    discounts: Yup.array(Yup.object({ id: Yup.string().optional() }).required()).optional(),
  }).optional(),
});

export type WebCalcRequestFromSchema = AssertSchemaMatchesModel<
  WebCalcRequest,
  Yup.InferType<typeof webCalcRequestSchema>
>;

// call before sending a request once the WebCalc integration is wired.
export const validateWebCalcRequest = (payload: unknown): boolean =>
  validateContract(webCalcRequestSchema, payload, 'WebCalcRequest');
